import React from "react";
import DashboardLayout from "../../layout/dashboardLayout";
import { BetSlipProvider } from "../../../context/BetSlipProvider";
import BetBuilderPanel from "../../betBuilder/BetBuilderPanel";
import Openbettable from "./openbettable";
import "../staightPage/staightPage.css";
import "./openbetPage.css";

const Openbet = () => {
  return (
    <DashboardLayout>
      <BetSlipProvider stayOnPageAfterSubmit>
        <section className="staightPage">
          <div className="pageContentPart">
            {/* Same scroll owner as the board: shell locks 100vh; this scrolls. */}
            <div className="staightPageCenterScroll">
              <Openbettable />
            </div>
          </div>
          <BetBuilderPanel />
        </section>
      </BetSlipProvider>
    </DashboardLayout>
  );
};

export default Openbet;
